import { Component, ErrorHandler, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import swal from 'sweetalert2';
import { UserService } from '../../../../shared/user.service';


@Component({
  selector: 'app-pharmacy-grid',
  templateUrl: './pharmacy-grid.component.html',
  styleUrls: ['./pharmacy-grid.component.css']
})
export class PharmacyGridComponent implements OnInit {
    
  title = "Pharmacy Details"
  P: any = {};
  e: any = {};
  dtOptions: any = {};
  ConsultancyList: any[] = [];
  mode: any;
  @ViewChild(DataTableDirective)
  datatableElement: DataTableDirective;
  isSearch: boolean;
  data: any;
  dtTrigger: Subject<any> = new Subject();                           
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;
  PrescriptionList: any;

  VI_Id: any;
  date: string;
  
  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler) { }
  
  ngOnInit(): void {


    // this.date =new Date();
    this.date = new Date().toISOString().split('T')[0];
    this.e.Delivery =this.date;
    this.GetAllConsultancy();
    $(document).ready(function () {
      //$('[data-toggle="tooltip"]').tooltip();
    });
    this.dtOptions = {
  
      dom: 'lBfrtip',
      lengthMenu: [[5, 10, 20, -1], [5, 10, 20, "All"]],
      scroll: "250px",
      select: true,
      buttons: [
        {
          extend: 'collection',
          text: 'Export',
          className: 'btn btn-radius',
          buttons: ['copy', 'csv', 'excel', 'pdf', 'print',]
        },
        { extend: 'colvis', text: 'Column Visibility', className: 'btn btn-radius' }
      ],
    }
  }
  
  GetAllConsultancy() {
    debugger;
    this.data = this.userService.GetAllPharamacy();
    this.data.subscribe((Response: any) => {
      this.ConsultancyList = Response.Result;
      this.rerender();
    }, (error) => {
      if (error.status == 401 || error.status == 500) {
        this.errorHandler.handleError(error);
      }
      else if (error.status == 400) {
        swal('Warning!', error.error.Message, 'warning');
      }
    });
  }
  

  GetId(id)
  {
    
    debugger;
    if (id > 0) 
    {

      this.data = this.userService.GetAllPrescription(id);
      this.data.subscribe((Response: any) => {
        this.PrescriptionList = Response.Result;
        this.rerender();
      }, (error) => {
        if (error.status == 401 || error.status == 500) {
          this.errorHandler.handleError(error);
        }
        else if (error.status == 400) {
          swal('Warning!', error.error.Message, 'warning');
        }
      });

    }
    if(id>0)
    {
      this.Getphasrbyid(id)
    }
  }
  /*for Datatable*/
  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }
  
  
  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }
  
  rerender(): void {
    try {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
      });
      this.dtTrigger.next();
    } catch (err) {
      console.log(err);
    }
  }

  
  GetIdvi(VI_Id)
  {
    
    debugger;
   this.VI_Id=VI_Id
   debugger;
   if (this.VI_Id > 0) 
   {
   this.Getphasrbyid(this.VI_Id)

   }
  }


   Getphasrbyid(id)
   {
    this.data = this.userService.GetByIdpharamacyrequests(id);
    this.data.subscribe((Response: any) => {
      this.e = Response;
      if (this.e.Delivery != null)
      this.e.Delivery = ((this.e.Delivery).split('T'))[0];
      this.rerender();
    }, (error) => {
      if (error.status == 401 || error.status == 500) {
        this.errorHandler.handleError(error);
      }
      else if (error.status == 400) {
        swal('Warning!', error.error.Message, 'warning');
      }
    });
   }

  
  Save(e)
  {
    debugger;
    this.e.VI_Id= this.VI_Id
    this.data = this.userService.CreatePharamcyrequest(e);
    this.data.subscribe(
      (response) => {
        swal('Success!', 'Details Updated Successfully .', 'success');
        this.router.navigate(['/home/PharmacyRequest']);
      }, (error) => {
        if (error.status == 401) {
          this.errorHandler.handleError(error);
        }
        else if (error.status == 400) {
          swal('Warning!', error.error.Message, 'warning');
        }
      });
  }
  }
  


// WEBPACK FOOTER //
// ./src/app/Pages/tasks/pharmacy/pharmacy-grid/pharmacy-grid.component.ts